'use client';

import React from 'react';
import { Spinner } from '@skin-seoul/design-system';
import { CART_QUERY_KEYS } from '@skin-seoul/service';
import { useMutationLoading } from '@skin-seoul/utils';
const CART_LOADING_INDICATOR_TEST_ID = 'cart-loading-indicator';

const CartLoaderBackdrop = () => {
  return (
    <div
      role="status"
      aria-label="Updating cart"
      aria-live="polite"
      className="absolute inset-0 bg-black/20 z-banner flex items-center justify-center"
      data-testid={CART_LOADING_INDICATOR_TEST_ID}
    >
      <Spinner className="text-primary-600" size="xl" />
    </div>
  );
};

export default CartLoaderBackdrop;

/** Observe writes only: quantity debounce and background reads keep the cart interactive. */
export function CartMutationLoader() {
  const isUpdating = useMutationLoading(CART_QUERY_KEYS.default());
  return isUpdating ? <CartLoaderBackdrop /> : null;
}
